import type { Dict } from './uk';

/** Polish. TODO: review by a native speaker before launch. */
export const pl: Dict = {
  'app.skip': 'Przejdź do treści',
  'app.loading': 'Ładowanie…',
  'nav.cases': 'Moje sprawy',
  'nav.privacy': 'Moje dane',
  'nav.main': 'Nawigacja główna',
  'lang.label': 'Język',
  'theme.label': 'Wygląd',
  'theme.system': 'Jak w systemie',
  'theme.light': 'Jasny',
  'theme.dark': 'Ciemny',

  'common.retry': 'Spróbuj ponownie',
  'common.back': 'Wstecz',
  'common.cabinet': 'Konto klienta',

  'login.title': 'Logowanie',
  'login.intro': 'Tutaj zobaczą Państwo, na jakim etapie jest sprawa, prześlą nam dokumenty i napiszą do opiekuna. Hasło nie jest potrzebne — wyślemy jednorazowy kod.',
  'login.method': 'Jak wysłać kod',
  'login.byPhone': 'SMS na telefon',
  'login.byEmail': 'E-mail',
  'login.phoneLabel': 'Numer telefonu',
  'login.emailLabel': 'Adres e-mail',
  'login.destHint': 'Ten, który podali Państwo naszemu opiekunowi.',
  'login.phonePlaceholder': '+48 600 000 000',
  'login.emailPlaceholder': 'imie@example.com',
  'login.submit': 'Wyślij kod',
  'login.sending': 'Wysyłamy…',
  'login.codeTitle': 'Wpisz kod',
  'login.codeSentPhone': 'Wysłaliśmy SMS na numer {dest}.',
  'login.codeSentEmail': 'Wysłaliśmy wiadomość na adres {dest}.',
  'login.codeNote': 'Jeśli mamy te dane kontaktowe, kod dotrze w ciągu minuty. Jest ważny 10 minut.',
  'login.codeLabel': 'Kod z 6 cyfr',
  'login.verify': 'Zaloguj się',
  'login.verifying': 'Sprawdzamy…',
  'login.resend': 'Wyślij kod ponownie',
  'login.resendIn': 'Nowy kod można wysłać za {time}',
  'login.resent': 'Wysłaliśmy nowy kod.',
  'login.change': 'Zmień telefon lub e-mail',
  'login.help': 'Kod nie dotarł? Prosimy zadzwonić — pomożemy.',
  'login.empty': 'Prosimy wpisać numer telefonu lub e-mail.',

  'err.invalid_destination': 'Wygląda na to, że w numerze lub adresie jest błąd. Prosimy sprawdzić.',
  'err.invalid_code': 'Kod jest nieprawidłowy lub wygasł. Prosimy sprawdzić cyfry albo poprosić o nowy kod.',
  'err.rate_limited': 'Zbyt wiele prób. Prosimy odczekać kilka minut i spróbować ponownie.',
  'err.rate_limited_wait': 'Zbyt wiele prób. Można spróbować ponownie za {time}.',
  'err.network': 'Brak połączenia. Prosimy sprawdzić internet i spróbować ponownie.',
  'err.unauthorized': 'Sesja wygasła. Prosimy zalogować się ponownie.',
  'err.forbidden': 'Brak dostępu do tej strony.',
  'err.not_found': 'Nie znaleziono tej strony ani dokumentu.',
  'err.validation': 'Prosimy sprawdzić wpisane dane.',
  'err.generic': 'Coś poszło nie tak. Prosimy spróbować ponownie lub napisać do nas na czacie.',
  'err.code_incomplete': 'Prosimy wpisać wszystkie 6 cyfr kodu.',

  'cases.title': 'Moje sprawy',
  'cases.empty': 'Nie ma tu jeszcze żadnej sprawy. Jeśli dopiero się Państwo z nami skontaktowali, sprawa pojawi się po rozmowie z opiekunem.',
  'cases.number': 'Sprawa nr {n}',
  'cases.updated': 'Aktualizacja: {date}',
  'cases.now': 'Teraz',
  'cases.open': 'Otwórz sprawę',

  'case.sections': 'Sekcje strony',
  'case.stages': 'Etapy',
  'case.stage.done': 'Zakończono',
  'case.stage.current': 'Teraz',
  'case.stage.next': 'Dalej',
  'case.needs': 'Czego potrzebujemy od Państwa',
  'case.needsIntro': 'Prosimy zrobić zdjęcie dokumentu telefonem lub wybrać plik. Ważne, aby tekst był dobrze widoczny.',
  'case.needsDone': 'Dziękujemy. W tej chwili niczego od Państwa nie potrzebujemy.',
  'case.needsCount': 'Pozostało: {n}',
  'case.rejectedReason': 'Co poprawić: {reason}',
  'case.rejectedNoReason': 'Opiekun wyjaśni na czacie, co trzeba poprawić.',
  'case.replaceHint': 'Wysłano zły plik? Można wysłać inny, dopóki go nie sprawdzimy.',

  'status.missing': 'Potrzebny',
  'status.optional': 'Opcjonalnie',
  'status.uploaded': 'W weryfikacji',
  'status.accepted': 'Przyjęty',
  'status.rejected': 'Do poprawy',

  'upload.takePhoto': 'Zrób zdjęcie',
  'upload.chooseFile': 'Wybierz plik',
  'upload.replace': 'Wyślij inny plik',
  'upload.limits': 'Zdjęcie lub PDF, do {mb} MB.',
  'upload.preparing': 'Przygotowujemy…',
  'upload.uploading': 'Przesyłanie: {pct}%',
  'upload.finishing': 'Zapisujemy…',
  'upload.done': 'Plik otrzymany. Wkrótce go sprawdzimy.',
  'upload.tooLarge': 'Plik jest za duży ({size}). Limit to {mb} MB. Prosimy zrobić zdjęcie ponownie lub zmniejszyć PDF.',
  'upload.badType': 'Ten typ pliku nie jest obsługiwany. Odpowiednie są zdjęcia (JPG, PNG, HEIC) lub PDF.',
  'upload.empty': 'Plik jest pusty. Prosimy wybrać go ponownie.',
  'upload.failed': 'Nie udało się przesłać pliku.',
  'upload.retry': 'Spróbuj ponownie',
  'upload.cancel': 'Anuluj',
  'upload.progress': 'Postęp przesyłania',

  'docs.fromUs': 'Dokumenty od nas',
  'docs.empty': 'Dokumenty, które przygotujemy, pojawią się tutaj.',
  'docs.download': 'Pobierz',
  'docs.opening': 'Otwieramy…',
  'docs.yours': 'Przesłane przez Państwa',

  'chat.title': 'Czat z opiekunem',
  'chat.intro': 'Prosimy pisać, kiedy to wygodne. Opiekun odpowie jak najszybciej.',
  'chat.urgentCall': 'W pilnych sprawach lepiej zadzwonić:',
  'chat.empty': 'Nie ma jeszcze wiadomości. Można zadać dowolne pytanie.',
  'chat.label': 'Wiadomość',
  'chat.placeholder': 'Napisz wiadomość…',
  'chat.send': 'Wyślij',
  'chat.sending': 'Wysyłanie…',
  'chat.failed': 'Nie wysłano.',
  'chat.retry': 'Wyślij ponownie',
  'chat.you': 'Ty',
  'chat.manager': 'Opiekun',
  'chat.offline': 'Brak połączenia. Nowe wiadomości pojawią się po jego przywróceniu.',

  'timeline.title': 'Historia',
  'timeline.empty': 'Brak zdarzeń.',
  'event.case_created': 'Sprawa otwarta',
  'event.state_changed': 'Nowy etap: {state}',
  'event.state_changed_plain': 'Sprawa przeszła do nowego etapu',
  'event.document_uploaded': 'Dokument otrzymany: {doc}',
  'event.document_accepted': 'Dokument przyjęty: {doc}',
  'event.documents_accepted': 'Dokumenty przyjęte: {docs}',
  'event.documents_uploaded': 'Dokumenty otrzymane: {docs}',
  'event.document_rejected': 'Dokument do poprawy: {doc}',
  'event.document_ready': 'Dokument przygotowany: {doc}',
  'event.document_plain': 'Zmiana w dokumentach',
  'event.message': 'Nowa wiadomość od opiekuna',
  'event.generic': 'Aktualizacja sprawy',
  'event.order_shipped': 'Zamówienie wysłane',
  'event.order_completed': 'Zamówienie zrealizowane',

  'privacy.title': 'Moje dane',
  'privacy.intro': 'Przechowujemy tylko to, co jest potrzebne do Państwa sprawy, i nie przekazujemy tego bez potrzeby.',
  'privacy.exportTitle': 'Kopia Państwa danych',
  'privacy.exportHint': 'Plik ze wszystkim, co o Państwu przechowujemy (zgodnie z RODO).',
  'privacy.export': 'Pobierz moje dane',
  'privacy.exporting': 'Przygotowujemy plik…',
  'privacy.exported': 'Plik zapisano na urządzeniu.',
  'privacy.erase': 'Jeśli chcą Państwo, abyśmy usunęli dane, prosimy o wiadomość. Odpowiemy w ciągu 30 dni.',
  'privacy.contacts': 'Kontakt',
  'privacy.phone': 'Telefon',
  'privacy.duty': 'Całodobowo',
  'privacy.email': 'E-mail',
  'privacy.dpo': 'Pytania o dane osobowe',
  'privacy.company': 'Firma',
  'privacy.address': 'Adres',
  'privacy.session': 'Wylogowanie',
  'privacy.logoutHint': 'Jeśli korzystają Państwo z cudzego telefonu lub komputera, prosimy się wylogować.',
  'privacy.logout': 'Wyloguj się',
  'privacy.loggingOut': 'Wylogowujemy…',

  // --- phase 5: steps, notifications, feedback, case site
  'nav.notifications': 'Powiadomienia',
  'notif.title': 'Powiadomienia',
  'notif.intro': 'Tutaj są zapisane wszystkie wiadomości dotyczące Państwa spraw, nawet jeśli e-mail lub SMS nie dotarł.',
  'notif.empty': 'Na razie nie ma powiadomień.',
  'notif.via.email': 'Wysłano e-mailem',
  'notif.via.sms': 'Wysłano SMS-em',
  'notif.via.telegram': 'Wysłano przez Telegram',
  'notif.via.viber': 'Wysłano przez Viber',
  'notif.via.whatsapp': 'Wysłano przez WhatsApp',
  'notif.logged': 'Zapisano w panelu',
  'notif.queued': 'Wyślemy rano',
  'notif.new': 'Nowe',
  'notif.unread': 'Nowe powiadomienia: {n}',
  'notif.more': 'Pokaż wcześniejsze',
  'notif.today': 'Dzisiaj',
  'notif.yesterday': 'Wczoraj',
  'step.accepted': 'Przyjęliśmy sprawę',
  'step.docs_collecting': 'Zbieramy dokumenty',
  'step.docs_ready': 'Dokumenty gotowe',
  'step.picked_up': 'Odebraliśmy ciało',
  'step.in_transit': 'W drodze',
  'step.border_crossed': 'Przekroczyliśmy granicę',
  'step.delivered': 'Dostarczyliśmy',
  'step.burial': 'Pochówek',
  'step.hint.accepted': 'Przyjęliśmy sprawę i już nad nią pracujemy.',
  'step.hint.docs_collecting': 'Zbieramy potrzebne dokumenty. Jeśli będziemy czegoś potrzebować od Państwa, napiszemy.',
  'step.hint.docs_ready': 'Dokumenty są gotowe. Przygotowujemy kolejny krok.',
  'step.hint.picked_up': 'Zadbamy o wszystko, co potrzebne.',
  'step.hint.in_transit': 'Damy znać, gdy przekroczymy granicę i gdy dotrzemy na miejsce.',
  'step.hint.in_transit_local': 'Damy znać, gdy dotrzemy na miejsce.',
  'step.hint.border_crossed': 'Granica za nami. Damy znać, gdy dotrzemy na miejsce.',
  'step.hint.delivered': 'Jesteśmy na miejscu. Opiekun skontaktuje się z Państwem w sprawie kolejnych kroków.',
  'step.hint.burial': 'Jesteśmy do dyspozycji, jeśli potrzebują Państwo pomocy. Można napisać do opiekuna na czacie.',
  'event.step': 'Nowy krok: {step}',
  'feedback.title': 'Jak sobie poradziliśmy?',
  'feedback.intro': 'Kilka słów od Państwa pomoże nam być uważniejszymi wobec innych rodzin.',
  'feedback.rating': 'Ocena od 1 do 5',
  'feedback.rate': '{n} z 5',
  'feedback.scale': '1 — źle, 5 — bardzo dobrze',
  'feedback.text': 'Co mogliśmy zrobić lepiej? (opcjonalnie)',
  'feedback.optOut': 'Nie wysyłajcie mi więcej takich próśb',
  'feedback.submit': 'Wyślij odpowiedź',
  'feedback.sending': 'Wysyłamy…',
  'feedback.pickRating': 'Prosimy wybrać ocenę.',
  'feedback.thanks': 'Dziękujemy. Państwa odpowiedź jest dla nas ważna.',
  'feedback.expired': 'Termin na odpowiedź minął. Zawsze mogą Państwo napisać do opiekuna w panelu.',
  'feedback.optedOut': 'Zrezygnowali Państwo z takich próśb, więc nie będziemy ich więcej wysyłać.',
  'feedback.optedOutDone': 'Nie będziemy już wysyłać takich próśb.',
  'feedback.notFound': 'Ten link jest nieważny. Jeśli chcą Państwo podzielić się wrażeniami, prosimy napisać do opiekuna w panelu.',
  'feedback.card': 'Opinia',
  'feedback.cardIntro': 'Jeśli mają Państwo chwilę, prosimy powiedzieć, jak sobie poradziliśmy.',
  'feedback.toCabinet': 'Przejdź do panelu',
  'privacy.feedbackTitle': 'Prośby o opinię',
  'privacy.feedbackHint': 'Po zakończeniu sprawy możemy raz zapytać, jak sobie poradziliśmy.',
  'privacy.feedbackOptOut': 'Nie wysyłajcie mi próśb o opinię',
  'privacy.saved': 'Zapisano.',
  'site.contacts': 'Kontakt',
};
